module.exports = __webpack_public_path__ + "static/media/logo.52b966af.png";